import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { DynamicTabsProps } from "../../types/config";
import {
  BRAND_COLOR,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const DynamicTabs: React.FC<DynamicTabsProps> = ({
  tabsConfig,
  defaultTab = 0
}) => {
  const { t } = useKivunovaTranslation();
  const [activeTab, setActiveTab] = useState(defaultTab);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box width="100%">
      {/* Tabs Header */}
      <Tabs
        value={activeTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{ mb: 2 }}
      >
        {tabsConfig.map((tab) => (
          <Tab
            key={tab.id}
            label={t(tab.labelKey, tab.defaultLabel)}
            id={`profile-tab-${tab.id}`}
            aria-controls={tab.ariaControls}
            style={{ textTransform: "none", color: BRAND_COLOR }}
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      {tabsConfig.map((tab) => (
        <Box
          key={tab.id}
          role="tabpanel"
          hidden={activeTab !== tab.id}
          id={tab.ariaControls}
          aria-labelledby={`profile-tab-${tab.id}`}
        >
          {activeTab === tab.id && tab.content}
        </Box>
      ))}
    </Box>
  );
};

export default DynamicTabs;
